import _ from 'lodash';

export default [
  'Raven', 'ResourceService',
  function ErrorHandler (Raven, ResourceService) {
    let errors = [];

    function throwError (title, message, context) {
      errors.push({
        title: title,
        message: message
      });

      ResourceService.releaseVersion()
        .then((version) => Raven.setRelease(version))
        .finally(() => logError(title, message, context))
      ;
    }

    function logError (title, message, context) {
      context = context || {};

      Raven.captureMessage(`${title}: ${message}`, {
        level: 'warning',
        extra: context
      });
    }

    function stopPromises (message) {
      return ResourceService.errorPromise(message);
    }

    function getErrors () {
      return _.clone(errors);
    }

    function clear () {
      errors.length = 0;
    }

    return {
      throwError: throwError,
      logError: logError,
      stopPromises: stopPromises,
      getErrors: getErrors,
      clear: clear
    };
  }
];



// WEBPACK FOOTER //
// ./source/client/data-providers/error-handler.js